






































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListJigyosho from '@/components/common/search/ListJigyosho.vue';
import { API_SEARCH_JIGYOSHO } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlJigyosho',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListJigyosho,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '事業所',
    },
    widthCd: {
      type: Number,
      default: 63, //21,
    },
    widthName: {
      type: Number,
      default: 85,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_JIGYOSHO,
    listJigyoshoShow: false,
    jigyoshoCd: 0,
    jigyoshoMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { jigyoshoCd, jigyoshoMei } = item;
      this.jigyoshoCd = jigyoshoCd;
      this.jigyoshoMei = jigyoshoMei;
      this.listJigyoshoShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listJigyoshoShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.jigyoshoCd = value;
      if (value) {
        this.getJigyoshoItem();
      } else {
        this.jigyoshoMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ jigyoshoCd: this.jigyoshoCd });
      }
    },
    getJigyoshoItem() {
      axios
        .get(API_SEARCH_JIGYOSHO, {
          params: { jigyoshoCd: this.jigyoshoCd, mukoUmuFlg: this.mukoUmuFlg },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.jigyoshoMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk && this.callbackOk({ jigyoshoCd: this.jigyoshoCd });
            return;
          }
          this.errors = clearNoDataError();
          const { jigyoshoMei } = res.data.responseData[0];
          this.jigyoshoMei = jigyoshoMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [jigyoshoCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.jigyoshoCd': {
      handler(newValue) {
        if (+newValue === +this.jigyoshoCd) return;
        this.jigyoshoCd = +newValue;
        if (newValue) {
          this.getJigyoshoItem();
        } else {
          this.jigyoshoMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.jigyoshoCd) {
      this.jigyoshoCd = +this.$attrs.jigyoshoCd;
    }
  },
});
